//
// Disable rules for layout effect imports since this is the file where
// we implement the workaround for SSR.
//
/* eslint-disable no-restricted-imports */
import { useEffect, useLayoutEffect } from 'react';

/**
 * Runs layout effect client side and normal effect server side.
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
